import React, { useRef } from 'react';
import { createPortal } from 'react-dom';

import useClickOutside from '../../../../common/hooks/useClickOutside';

import { IPopup } from '../../types/IPopup';

import Icon from '../../icon/icon';

import './popupWrapper.scss';

const PopupWrapper: React.FC<IPopup> = ({ children, onClose, className }) => {
  const popupRef = useRef(null);

  const modalElement = document.getElementById('popup-root');

  useClickOutside(popupRef, onClose);

  return createPortal(
    (
      <div className={`popup-wrapper ${className ? className : ''}`} ref={popupRef}>
        <Icon className='close-popup-btn pointer' name='fas fa-circle-xmark' onClick={onClose} />
        {children}
      </div>
    ),
    modalElement);
};

export default PopupWrapper;